import { createFileRoute } from '@tanstack/react-router'

import { SectionsSetupListView } from '@/modules/sections'

export const Route = createFileRoute('/_auth/sections/setup/')({
  component: SectionsSetupListView
})
